import { useContext, useState } from "react";
import { GlobalRefContext } from "../store/GlobalRefs";
import { StoreContext } from "../store/Store";
import { actionTypes } from "../store/storeTypes";

const menuOptions = [
  "Select Country",
  "Jurisdiction",
  "Bank/Credit/Financial Institution",
  "Corporation",
  "Sovereign-owned Entity",
  "Investment Fund",
  "Central Bank",
  "Partnership",
  "Insurance Company",
  "Pension Fund",
  "Sovereign",
  "Investment Firm/Broker Dealer",
  "Local Authority",
  "International Entity",
  "Hedge Fund",
  "State of a Federal Sovereign",
];

export const Menu = () => {
  const [store, dispatch] = useContext(StoreContext);
  const grefs = useContext(GlobalRefContext);
  const [hovered, setHovered] = useState(null);

  const { menuSelection, mode } = store;

  const menuStyle = {
    height: grefs.menuRef.current,
    width: "100%",
    boxSizing: "border-box",
    display: "flex",
    justifyContent: "start",
    gap: 2,
    alignItems: "center",
    fontSize: 10,
  };

  const buttonStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 8,
    padding: 10,
    margin: 10,
  };
  const hoverStyle = { ...buttonStyle, border: "1px solid black" };
  const selectedStyle = {
    ...buttonStyle,
    backgroundColor: "#BC9669",
    color: "#ffffff",
  };

  const onClick = (item) => {
    //Clear selected country data
    // dispatch({ type: actionTypes.SET_SELECTED_COUNTRY, payload: null }); //{value:null,label:null}
    dispatch({ type: actionTypes.SET_COUNTRY_DATA, payload: null });
    dispatch({ type: actionTypes.SET_MENU_SELECTION, payload: item });
  };

  return mode === "layout" ? (
    <div style={menuStyle}>
      {menuOptions.map((item, i) => {
        return (
          <div
            key={i}
            style={
              menuSelection === item
                ? selectedStyle
                : hovered === i
                ? hoverStyle
                : buttonStyle
            }
            onMouseEnter={() => setHovered(i)}
            onMouseLeave={() => setHovered(null)}
            onClick={() => onClick(item)}
          >
            {item}
          </div>
        );
      })}
    </div>
  ) : null;
};
